import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import SharedButton from "../../components/Shared/SharedButton";
import CustomerTable from "./CustomerTable";
import { useNavigate } from "react-router-dom";
import SearchField from "../../components/Shared/SearchField";
import useFetchData from "../../hooks/useFetchData";
import useDebounce from "../../hooks/useDebounce";

export default function CustomerMain() {
  const { data: customersData, loading, executeFetch } = useFetchData();
  const { t } = useTranslation();
  const navigator = useNavigate();
  const [searchText, setSearchText] = useState("");
  const debouncedSearchQuery = useDebounce(searchText, 500);

  const getPayload = useCallback((params = {}) => {
    return {
      page: 1,
      per_page: 10,
      query: searchText,
      ...params
    };
  }, [searchText]);

  useEffect(() => {
    executeFetch("POST", "listCustomers", getPayload({ query: debouncedSearchQuery }));
  }, [executeFetch, debouncedSearchQuery]);

  const handleSearch = (event) => {
    setSearchText(event?.target?.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "listCustomers", getPayload({
      page: newPage,
      per_page: newRowsPerPage,
      query: debouncedSearchQuery
    }));
  };

  return (
    <>
      <div>
        <div className="flex justify-end mb-2">
          <div className="flex items-center gap-2">
            <div className="flex gap-2">
              <SearchField
                className="w-full md:!w-[300px]"
                placeholder={t("Search by customer name")}
                value={searchText}
                onChange={handleSearch}
                handleClearClick={handleClearSearch}
              />
            </div>
            <SharedButton
              label={t("CreateCustomer")}
              icon="pi pi-plus"
              onClick={() => navigator("/manager/customers/create")}
              className="bg-primary primary-btn"
            />
          </div>
        </div>
        <CustomerTable
          data={customersData}
          loading={loading}
          onPageChange={handlePageChange}
          onRefresh={() => executeFetch("POST", "listCustomers", getPayload({ query: debouncedSearchQuery }))}
        />
      </div>
    </>
  );
}
